import { ComponentProps, ReactNode } from "react";

import { Ds } from "@accurx/design";

interface PatientSearchTooltiptProps {
    children: ReactNode;
    text: string;

    align?: ComponentProps<typeof Ds.Tooltip.Content>["align"];
}

export const PatientSearchTooltip = ({
    children,
    text,
    align = "center",
}: PatientSearchTooltiptProps) => {
    return (
        <Ds.Tooltip>
            <Ds.Tooltip.Trigger>{children}</Ds.Tooltip.Trigger>
            <Ds.Tooltip.Content
                color="white"
                side="bottom"
                align={align}
                style={{ zIndex: 1000 }}
            >
                <Ds.Text weight="bold" color="white">
                    {text}
                </Ds.Text>
            </Ds.Tooltip.Content>
        </Ds.Tooltip>
    );
};
